import OverviewContainer from "./OverviewContainer";

function Overview() {
  return <OverviewContainer />;
}

export default Overview;
